import { FC } from 'react';
import { Tooltip, TwoLinesCell } from '@silverfort/sf-components';
import { SERVICE_ACCOUNT_TYPES } from '@silverfort-nodelibs/common/utils/consts';

interface TypeColumnProps {
    type: string;
    category: string;
}

const PresentedCategory = {
    [SERVICE_ACCOUNT_TYPES.MACHINE_TO_MACHINE.type]: SERVICE_ACCOUNT_TYPES.MACHINE_TO_MACHINE.title,
    [SERVICE_ACCOUNT_TYPES.HYBRID.type]: SERVICE_ACCOUNT_TYPES.HYBRID.title,
    [SERVICE_ACCOUNT_TYPES.DORMANT.type]: SERVICE_ACCOUNT_TYPES.DORMANT.title,
    [SERVICE_ACCOUNT_TYPES.SCANNER.type]: SERVICE_ACCOUNT_TYPES.SCANNER.title,
    [SERVICE_ACCOUNT_TYPES.REMOVED.type]: SERVICE_ACCOUNT_TYPES.REMOVED.title
};

const TypeColumn: FC<TypeColumnProps> = ({ type, category }) => {
    return (
        <TwoLinesCell
            topElement={
                <Tooltip title={type}>
                    <span>{type}</span>
                </Tooltip>
            }
            bottomText={PresentedCategory[category] || ''}
        />
    );
};

export default TypeColumn;
